// src/app/core/interceptors/plan-limit.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { PlanErrorHandlerService } from '../services/plan-error-handler.service';

/**
 * Interceptor que detecta errores HTTP 402 (Payment Required)
 * y muestra automáticamente el modal de upgrade de plan.
 */
export const planLimitInterceptor: HttpInterceptorFn = (req, next) => {
  const planErrorHandler = inject(PlanErrorHandlerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Detectar error 402 - Límite de plan excedido
      if (error.status === 402) {
        planErrorHandler.handlePlanLimitError(error);
      }

      // Detectar error 403 con mensaje de empresa no operativa
      if (error.status === 403) {
        const message = error.error?.message?.toLowerCase() || '';
        
        if (message.includes('trial') || 
            message.includes('expirado') || 
            message.includes('suspendida') ||
            message.includes('bloqueada')) {
          
          planErrorHandler.showUpgradeModal({
            tipoLimite: 'FEATURE',
            valorActual: 0,
            valorMaximo: 0,
            planActual: '',
            mensaje: error.error?.message || 'Tu cuenta necesita atención'
          });
        }
      }

      return throwError(() => error);
    })
  );
};